module.exports = __webpack_public_path__ + "static/all-cf818e911885cebf4c80b2df664c3e6d.png";